import { Box, Container, Link, Typography } from '@mui/material'
//https://grobotic.app/legal/chrome-extension-privacy
const ChromeExtensionPrivacy = () => {
  return (
    <Container maxWidth="md" sx={{ py: 6 }}>
      <Typography variant="h3" component="h1" gutterBottom sx={{ borderBottom: '2px solid #4285f4', pb: 1 }}>
        Grobotic Activity Tracker - Privacy Policy
      </Typography>

      <Typography variant="body2" color="text.secondary" gutterBottom>
        Last updated: January 29, 2026
      </Typography>

      <Typography paragraph sx={{ mt: 3 }}>
        This privacy policy describes how the Grobotic Activity Tracker Chrome extension ("Extension") collects, uses,
        and protects your information.
      </Typography>

      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Data We Collect
      </Typography>

      <Typography variant="h6" component="h3" sx={{ mt: 3, mb: 1 }}>
        1. Account Information
      </Typography>
      <Box component="ul" sx={{ pl: 3 }}>
        <li>
          <Typography>Email address, name, and profile photo from Google Sign-In</Typography>
        </li>
        <li>
          <Typography>
            <strong>Purpose:</strong> To identify you as a Grobotic team member
          </Typography>
        </li>
      </Box>

      <Typography variant="h6" component="h3" sx={{ mt: 3, mb: 1 }}>
        2. Browsing Activity (Limited)
      </Typography>
      <Box component="ul" sx={{ pl: 3 }}>
        <li>
          <Typography>URLs visited on Google Ads (ads.google.com) only</Typography>
        </li>
        <li>
          <Typography>Google Ads account IDs and account names extracted from page content</Typography>
        </li>
        <li>
          <Typography>Time spent on Google Ads pages, tracked per-account</Typography>
        </li>
        <li>
          <Typography>
            <strong>Purpose:</strong> To track work time for team productivity reporting
          </Typography>
        </li>
      </Box>

      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        How We Use Your Data
      </Typography>
      <Box component="ul" sx={{ pl: 3 }}>
        <li>
          <Typography>Display your activity in Grobotic team reports</Typography>
        </li>
        <li>
          <Typography>Attribute tracked time to the correct team member</Typography>
        </li>
        <li>
          <Typography>Map time to specific Google Ads client accounts</Typography>
        </li>
        <li>
          <Typography>Match Google Ads accounts to organizations in our system for reporting</Typography>
        </li>
      </Box>

      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Data Storage
      </Typography>
      <Box component="ul" sx={{ pl: 3 }}>
        <li>
          <Typography>Data is stored on Grobotic servers (AWS)</Typography>
        </li>
        <li>
          <Typography>Local browser storage caches your sign-in status and recent sessions</Typography>
        </li>
      </Box>

      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Data Sharing
      </Typography>
      <Box component="ul" sx={{ pl: 3 }}>
        <li>
          <Typography>
            We do <strong>NOT</strong> sell your data
          </Typography>
        </li>
        <li>
          <Typography>
            We do <strong>NOT</strong> share data with third parties
          </Typography>
        </li>
        <li>
          <Typography>
            Data is only visible to you and authorized administrators in your Gro marketing organization
          </Typography>
        </li>
      </Box>

      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Your Rights
      </Typography>
      <Box component="ul" sx={{ pl: 3 }}>
        <li>
          <Typography>Sign out anytime to stop all tracking</Typography>
        </li>
        <li>
          <Typography>
            Contact <Link href="mailto:ccavanaugh@gromarketing.com">ccavanaugh@gromarketing.com</Link> to request data
            deletion
          </Typography>
        </li>
      </Box>

      <Typography variant="h5" component="h2" sx={{ mt: 4, mb: 2 }}>
        Contact
      </Typography>
      <Typography paragraph>
        Questions? Email <Link href="mailto:ccavanaugh@gromarketing.com">ccavanaugh@gromarketing.com</Link>
      </Typography>
    </Container>
  )
}

export default ChromeExtensionPrivacy
